/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * 
 * @export
 * @interface GetNftTrackersResponse
 */
export interface GetNftTrackersResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetNftTrackersResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<NftTracker>}
     * @memberof GetNftTrackersResponse
     */
    nftTrackers: Array<NftTracker>;
}

/**
 * Check if a given object implements the GetNftTrackersResponse interface.
 */
export function instanceOfGetNftTrackersResponse(value: object): value is GetNftTrackersResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('nftTrackers' in value) || value['nftTrackers'] === undefined) return false;
    return true;
}

export function GetNftTrackersResponseFromJSON(json: any): GetNftTrackersResponse {
    return GetNftTrackersResponseFromJSONTyped(json, false);
}

export function GetNftTrackersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftTrackersResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'nftTrackers': ((json['nftTrackers'] as Array<any>).map(NftTrackerFromJSON)),
    };
}

export function GetNftTrackersResponseToJSON(json: any): GetNftTrackersResponse {
    return GetNftTrackersResponseToJSONTyped(json, false);
}

export function GetNftTrackersResponseToJSONTyped(value?: GetNftTrackersResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'nftTrackers': ((value['nftTrackers'] as Array<any>).map(NftTrackerToJSON)),
    };
}

